import { SidePhotoContentCard } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { GetSidePhotoContentCardModel } from './C13SidePhotoContentCard.service';
import { C13SidePhotoContentCardProps } from './C13SidePhotoContentCard.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { getCheckbox } from 'src/shared/param-utils';

export const Default = (props?: C13SidePhotoContentCardProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <SidePhotoContentCard
      verticalSpacing
      id={props.params?.AnchorLinkTargetName}
      className={translationClasses(props.params)}
      data-component={marketingRenderingName}
      shouldLazyLoad={getCheckbox(props?.params?.ShouldLazyLoad)}
      {...GetSidePhotoContentCardModel({ props, isEditing: sitecoreContext?.pageEditing || false })}
    />
  );
};
